export default __webpack_public_path__ + "./images/mm.1bf6244c.png";